import "./CardNoticiasBlog.css";
import BtnPost from "../../../../shared/btn/btn";
import assetsRoute from "../../../../utilities/assetsRoute";

const CardNoticiasBlog = (props) => {
  const data = props.data;
  const key = props.key ? props.key : 1;

  const { date, cat, title, featuredImg, excerpt, link, url } = data;

  const fecha = new Date(date).toLocaleDateString();
  const htmlLang = document.documentElement.lang;
  const baseUrl = link.split(".org")[0] + ".org";
  const urlPath = new URL(link);
  const pathAfterDomain = urlPath.pathname;

  const isLangEnUS = htmlLang === "en-US";

  const finalLink = isLangEnUS
    ? `${baseUrl}/en${pathAfterDomain}`
    : `${baseUrl}${pathAfterDomain}`;

  return (
    <div className="block-card">
      <div className="block-card__content">
        <a
          className="block-card__head"
          href={url ? url : finalLink}
          target={url ? "_blank" : ""}
        >
          <span className="block-card__date">{fecha}</span>
          <img src={featuredImg} alt="" className="block-card__img" />
        </a>
        <div className="block-card__body">
          <span className="block-card__category">{cat}</span>
          <h3 className="block-card__title">{title}</h3>
          <div className="block-card__decription">
            <p>{excerpt.replace(/&hellip;/g, "...")}</p>
          </div>
          <BtnPost
            target={url ? "_blank" : ""}
            btnLink={url ? url : finalLink}
            btnType={"secundary-button"}
            text={props.name == "Entradas" ? "Ver blog" : "Ver noticia"}
            svgIcon={assetsRoute("arrow-right", "icons", ".svg")}
          />
        </div>
      </div>
    </div>
  );
};

export default CardNoticiasBlog;
